enum SearchActions {
    QuerySearch = 'search/QUERY_SEARCH',
    ClearSearch = 'search/CLEAR_SEARCH'
}

export const SearchActionTypes = {
    ...SearchActions
};
